// extracted by mini-css-extract-plugin
export var innerStyle = "sr_cta-module--innerStyle--5FqPC";
export var leftStyle = "sr_cta-module--leftStyle--VFk3V";
export var rightStyle = "sr_cta-module--rightStyle--o+Z--";
export var textStyle = "sr_cta-module--textStyle--ppkrI";
export var wrapperStyle = "sr_cta-module--wrapperStyle--WqUzk";